import { partyLabel, paymentLabel } from "../lib/purchaseContractOptions";

/** @type {import('../lib/dataTable').DataTableColumn[]} */
export const CONTRACT_COLUMNS = [
  { id: "contract_number", label: "Contract #", accessorKey: "contract_number", filterType: "text" },
  {
    id: "contract_phase",
    label: "Phase",
    accessorKey: "contract_phase",
    filterType: "select",
    filterOptions: [
      { value: "", label: "All" },
      { value: "PRE_ARRIVAL", label: "Pre-arrival" },
      { value: "ARRIVAL", label: "Arrival" },
    ],
    matchFilter: (row, value) => !value || row.contract_phase === value,
  },
  { id: "contract_date", label: "Date", accessorKey: "contract_date", filterType: "date" },
  { id: "purchase_type", label: "Type", accessorKey: "purchase_type", filterType: "text" },
  { id: "party", label: "Party", accessor: partyLabel, filterType: "text" },
  { id: "gate_pass_code", label: "Gate pass", accessorKey: "gate_pass_code", filterType: "text" },
  { id: "quality", label: "Quality", accessorKey: "quality", filterType: "text" },
  { id: "quantity", label: "Qty", accessorKey: "quantity", filterType: "text" },
  { id: "price", label: "Rate", accessorKey: "price", filterType: "text" },
  { id: "payment", label: "Payment", accessor: paymentLabel, filterType: "text" },
  { id: "stock_lab", label: "Stock / Lab", sortable: false },
  { id: "broker_name", label: "Broker", accessor: (row) => row.broker_party_name || row.broker_name || "", filterType: "text" },
  {
    id: "status",
    label: "Status",
    accessorKey: "status",
    filterType: "select",
    filterOptions: [
      { value: "", label: "All" },
      { value: "ACTIVE", label: "Active" },
      { value: "CLOSED", label: "Closed" },
      { value: "CANCELLED", label: "Cancelled" },
    ],
    matchFilter: (row, value) => !value || row.status === value,
  },
];
